export const getRequestsOutgoing = (state) => state;
export const getRequestsIncoming = (state) => state;
export const getRequestCreationData = (state) => state.request.createRequest;
export const getRequestCompanyVehicles = (state) => state.request.createRequest;
export const getRequestDetails = (state) => state.request.details;
